import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/hooks/useLenis";

const LINKS = [
  { id: "bio", label: "Bio" },
  { id: "releases", label: "Releases" },
  { id: "newsletter", label: "Mailing list" },
];

export function Nav() {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#0B0B0C]/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 md:px-10">
        <button data-testid="nav-logo" onClick={() => go("top")} className="shrink-0" aria-label="Stillworking Production">
          <img src="/media/logo-light.png" alt="Stillworking Production" className="h-7 w-auto md:h-8" />
        </button>
        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-link-${l.id}`} onClick={() => go(l.id)} className="group relative font-mono text-xs uppercase tracking-[0.22em] text-[var(--stone)] transition-colors hover:text-[var(--bone)]">
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[var(--gold)] transition-[width] duration-500 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen((v) => !v)} className="md:hidden" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} className="overflow-hidden border-t border-white/10 bg-[#0B0B0C]/95 md:hidden">
            <div className="flex flex-col gap-1 px-5 py-6">
              {LINKS.map((l, i) => (
                <button key={i} data-testid={`nav-mobile-link-${i}`} onClick={() => go(l.id)} className="py-2 text-left font-display text-4xl font-extrabold uppercase tracking-tight">
                  {l.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
